<template>
      <section class="wrapper int-body">
        <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/interior-bg.jpg" alt=""
      aria-hidden="true" class="int-bg" decoding="async">
        <component :is="WidgetComponent"  :campaign-id="$t('CampaignID')"></component>
      </section>
</template>

<script>
import CampaignWidgets from '../Home/Homepagecomponents/CampaignWidgets.vue';

export default {
  components: { CampaignWidgets },
  props: {

  },
  data() {
    return {
      showComponent: false,
      WidgetComponent: CampaignWidgets,
    };
  },
};
</script>
